module.exports = __webpack_public_path__ + "fonts/b978d1b.woff";